module.exports = __webpack_public_path__ + "img/product5-1.dec036af.png";